var quizQuestions = [
    {
        question: "Was beschreibt Dich am Besten?",
        answers: [
            {
                type: "1",
                content: "Experte"
            },
            {
                type: "2",
                content: "Unternehmer"
            },
            {
                type: "3",
                content: "Künstler"
            }
        ]
    },
    {
      question: "Möchtest Du auf die Bühne?",
      answers: [
          {
              type: "1",
              content: "Ja"
          },
          {
              type: "2",
              content: "Vielleicht"
          },
          {
              type: "3",
              content: "Nein"
          }
      ]
  },
  {
      question: "Kannst Du Dir vorstellen ein Buch zu schreiben?",
      answers: [
          {
              type: "3",
              content: "Ja"
          },
          {
              type: "1",
              content: "Vielleicht"
          },
          {
              type: "2",
              content: "Nein"
          }
      ]
  },
  {
      question: "Was beschreibt Dich am Besten?",
      answers: [
          {
              type: "3",
              content: "kreativ"
          },
          {
              type: "2",
              content: "strukturiert"
          },
          {
              type: "1",
              content: "sozial"
          }
      ]
  },
  {
      question: "Möchtest Du..",
      answers: [
          {
              type: "2",
              content: "ein Produkt verkaufen?"
          },
          {
              type: "1",
              content: "Dich verkaufen?"
          },
          {
              type: "3",
              content: "Deine Botschaft verkünden?"
          }
      ]
  }
  ];
  
  export default quizQuestions;
  